import Vue from 'vue';
import VueChatScroll from 'vue-chat-scroll';
import VueShortkey from 'vue-shortkey';
import Vuelidate from 'vuelidate';
import VueMq from 'vue-mq';
import VCalendar from 'v-calendar';
import ePersonamAuth from './plugins/ePersonamAuth';
import InfiniteLoading from 'vue-infinite-loading';
import notificationClient from 'epersonam-notification-client';
import ToggleButton from 'vue-js-toggle-button';
import { staticComponents } from './multiappOldComponents.js';
import { componentsAsync } from './asyncLoader.js';

import { addCss, addJs } from '@/epersonam/resources.js';

Vue.use(VueChatScroll);
Vue.use(VueShortkey);
Vue.use(ePersonamAuth);
Vue.use(VCalendar);
Vue.use(notificationClient);
Vue.use(Vuelidate);
Vue.use(ToggleButton);
Vue.use(InfiniteLoading, {
  props: {
    spinner: 'default',
    /* other props need to configure */
  },
  system: {
    throttleLimit: 50,
    /* other settings need to configure */
  },
});

Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    phone: 767,
    tablet: 1024,
    desktop: Infinity,
  },
  defaultBreakpoint: 'desktop', // customize this for SSR
});

const externalDependencies = async (dependencies = []) => {
  try {
    await Promise.all(
      dependencies.map(async (dep) => {
        const { type, path, name } = dep;
        type == 'js' ? await addJs(path, name) : await addCss(path, name);
      }),
    );
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const loadComponent = async (notLoaded, responses) => {
  try {
    const pathKey = Object.keys(notLoaded.path);
    const pathName = pathKey[0];
    const { default: defaultData } = await notLoaded.path[pathName]();
    responses[notLoaded['key']] = defaultData;
  } catch (error) {
    console.error(error);
  }
};

const loadPaths = async (notLoadedComponent) => {
  const responses = {};
  await Promise.all(
    notLoadedComponent.map(async (notLoaded) => {
      await externalDependencies(notLoaded.dependencies ?? []);
      await loadComponent(notLoaded, responses);
    }),
  );
  return responses;
};

const loadAsyncComponents = async (componentsFounds) => {
  if (!componentsFounds.length) {
    return window.asyncComponents;
  }
  const notLoadedComponent = componentsFounds.filter((component) => !window.asyncComponents[component.key]);
  const componentsLoaded = await loadPaths(notLoadedComponent);
  window.asyncComponents = { ...window.asyncComponents, ...componentsLoaded };
  return window.asyncComponents;
};

const findAsyncComponent = (element) => {
  return componentsAsync.filter((component) => element.find(component.key).length);
};

window.asyncComponents = {};

window.updateVueInstances = async (ev, selector = '.vue-container') => {
  selector = selector || '.vue-container';
  const appElements = Array.from(document.querySelectorAll(selector));

  if (appElements.length !== 0) {
    for (const el of appElements) {
      const elData = $(el)
        .removeClass('vue-container') // removes .vue-container class to say that this component will be initializated
        .data('embedded');

      const asyncComponents = await loadAsyncComponents(findAsyncComponent($(el)));

      new Vue({
        el,
        data() {
          return elData || {};
        },
        components: {
          ...asyncComponents,
          ...staticComponents,
        },
      });
    }
  }
};

const showApplication = () => {
  const html = document.getElementsByTagName('html');
  html[0].style.display = 'block';
};

document.addEventListener('DOMContentLoaded', async () => {
  await window.updateVueInstances();

  if (window.config.layout_light) showApplication();
});
